import { useContext, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { AxiosContext } from "services/axios.context";

const useDeleteRelease = (id) => {
  const { client } = useContext(AxiosContext);
  const [error, setError] = useState("");
  const queryClient = useQueryClient();
  return {
    deleteRelease: useMutation(() => client.delete(`releases/${id}/`), {
      onSuccess: () => {
        console.debug(`release-${id} deleted`);
        queryClient.invalidateQueries(`releases`);
      },
    }),
    error: error,
  };
};

export default useDeleteRelease;
